import { render } from "./AboutUsSection.vue?vue&type=template&id=45d65b3f&scoped=true"
import script from "./AboutUsSection.vue?vue&type=script&lang=js"
export * from "./AboutUsSection.vue?vue&type=script&lang=js"

import "./AboutUsSection.vue?vue&type=style&index=0&id=45d65b3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d65b3f"]])

export default __exports__